module.exports = __webpack_public_path__ + "static/media/crfCardsAssetsPo.1526848d.svg";